import * as React from 'react';
import cn from 'clsx';

import { TNotificationType } from '../../types';

import * as styles from './styles.css';

export interface INotificationLayoutProps {
  children: React.ReactNode;
  type: TNotificationType;
  footer?: React.ReactNode;
  testId?: string;
}

export const NotificationLayout: React.FC<INotificationLayoutProps> = props => {
  const { children, footer, testId, type } = props;

  return (
    <div className={cn(styles['container'], styles[type])} data-testid={testId}>
      <div className={styles['content-area']}>{children}</div>
      {footer && <div className={styles['footer-area']}>{footer}</div>}
    </div>
  );
};
